import { CityInformation } from './../../classes/city-information';
import { EventEmitterService } from './../../event-emitter.service';
import { Component, OnInit, Renderer2, HostListener, Directive, ElementRef, Input } from '@angular/core';
import { Location } from '@angular/common';




@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  
})
export class HeaderComponent implements OnInit {
  @Input() data: CityInformation[] = [];

  constructor(private render: Renderer2,
              private eventEmitterService: EventEmitterService,
              private location: Location) { }

  ngOnInit() {



  }


  navToggleClicked(event: Event) {

    const mainNavElement = document.querySelector('#main-nav');
    if (mainNavElement.classList.contains('open')) {
      this.render.removeClass(mainNavElement, 'open');
    } else {
      this.render.addClass(mainNavElement, 'open');
    }
  }

  cityClicked(event, index: number, path: string) {

    event.preventDefault();

    // emit to AppComponent to change swiper
    this.eventEmitterService.onFirstComponentButtonClick(index);

    // update URL without reloading
    this.location.go(path);

    const navtoggleElement = document.querySelector('#nav-toggle');
    if (!navtoggleElement.classList.contains('collapsed')) {
        this.render.addClass(navtoggleElement, 'collapsed');
    }

    const mainNav = document.querySelector('#main-nav');
    if (mainNav.classList.contains('open')) {
        this.render.removeClass(mainNav, 'in');
        this.render.addClass(mainNav, 'collapse');
        this.render.removeClass(mainNav, 'open');
    }

  }


  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event) {

    const headerelement = document.querySelector('.header');
    if (document.documentElement.scrollTop > 100) {


      this.render.addClass(headerelement, 'active');
    } else {
        // remove the background property so it comes transparent again (defined in your css)
        this.render.removeClass(headerelement, 'active');
    }
  }

}
